import { Box, Flex } from "@chakra-ui/react";
import React, { useEffect, useRef } from "react";
import { getImageSrc } from "data/svgData";
import { useSelector } from "react-redux";
import Loader from "component/Loader";
import PlaceHolder from "component/PlaceHolder";
import Animation from "component/Animation";
import ReactMarkdown from "react-markdown";
import Thinking from "component/Thinking";
import SvgImage from "component/SvgData";

const ChatInterface = ({ widget, dataPadding, id }) => {
  const { loading, chats } = useSelector((state) => state.chats);

  const scrollRef = useRef(null);

  useEffect(() => {
    scrollRef?.current?.scrollIntoView({ behavior: "smooth" });
  }, [chats]);

  if (loading) return <Loader />;
  return (
    <>
      <Box className="flex-grow flex flex-col overflow-hidden overflow-y-auto pb-2">
        <Box className="widget-side-div-outer">
          <Box
            style={{ padding: "5px" }}
            className="widget-side-div-outer-main"
          >
            <Box className="wrap-parent">
              {widget &&
                widget["initial_messages"]?.map((item, id) => {
                  return (
                    <Box className="widget-side-div-outer-new" key={id}>
                      {widget?.bot_avatar ? (
                        <SvgImage widgetData={widget} />
                      ) : null}

                      <Box className="widget-side-div-outer-new-main" marginTop={3}>
                        <p
                          style={{
                            backgroundColor: widget?.message_background,
                            color:  widget?.bot_message_colour,
                            padding: dataPadding,
                            borderRadius: "8px",
                          }}
                        >
                          {item}{" "}
                        </p>
                      </Box>
                    </Box>
                  );
                })}
            </Box>
          </Box>
        </Box>

        {chats?.length > 0 ? (
          chats.map((item, id) =>
            !item?.isFromUser ? (
              <Box className="widget-side-div-outer" key={id}>
                <Box
                  style={{ padding: "5px" }}
                  className="widget-side-div-outer-main"
                >
                  {widget?.bot_avatar ? (
                    <Box className="main-form-upper-logo-inner-bot">
                      <SvgImage widgetData={widget} />
                    </Box>
                  ) : (
                    ""
                  )}

                  <Box
                    className="widget-side-div-outer-new"
                    style={{
                      backgroundColor: widget?.message_background,
                      color: widget?.bot_message_colour,
                      padding: dataPadding,
                      maxWidth: "1600px",
                    }}
                  >
                    <Box className="widget-side-div-outer-new-main">
                      {item?.text ? (
                        item?.isNew && item?.text === "" ? (
                          <Flex borderRadius="md">
                            <Flex direction="column">
                              <Flex
                                p={2}
                                borderRadius="md"
                                wordBreak="break-word"
                              >
                                <Thinking />
                              </Flex>
                            </Flex>
                          </Flex>
                        ) : (
                          <Flex
                            mb={!item?.isFromUser ? 1 : 2}
                            borderRadius="md"
                          >
                            <Flex direction="column">
                              <Flex borderRadius="md" wordBreak="break-word">
                                <Box>
                                  {item?.isNew && item?.text !== "" ? (
                                    <Animation msg={item?.text} />
                                  ) : (
                                    <Box ml={1}>
                                      <ReactMarkdown>
                                        {item?.text}
                                      </ReactMarkdown>
                                    </Box>
                                  )}
                                </Box>
                              </Flex>
                            </Flex>
                          </Flex>
                        )
                      ) : (
                        <Flex borderRadius="md">
                          <Flex direction="column">
                            <Flex
                              p={2}
                              borderRadius="md"
                              wordBreak="break-word"
                            >
                              <Thinking />
                            </Flex>
                          </Flex>
                        </Flex>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Box>
            ) : (
              <Box className="widget-side-div-outer" key={id}>
                <Box className="widget-side-div-outer-new-3">
                  <Box
                    className="widget-side-div-outer-new"
                    style={{
                      backgroundColor: widget?.human_message_background,
                      color: widget?.human_message_colour,
                      padding: dataPadding,
                    }}
                  >
                    <Box className="widget-side-div-outer-new-main">
                      <p>{item?.text}</p>
                    </Box>
                  </Box>
                </Box>
              </Box>
            )
          )
        ) : (
          <Box h="calc(100vh - 100px)" p={8} borderRadius={8}>
            <Box display="flex" justifyContent="center" alignItems="center">
              <img src="null" alt="" className="custom-im" />
            </Box>
            <Box
              fontSize={20}
              fontWeight={600}
              display="flex"
              justifyContent="center"
              color="GrayText"
            >
              <PlaceHolder />
            </Box>
          </Box>
        )}

        <Box ref={scrollRef}></Box>
        <Box className="widget-side-div-outer-list">
          <Box className="widget-side-div-outer-content">
            <ul className="widget-side-div-outer-ul"></ul>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ChatInterface;
